var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.headers.actions,
          "left-side-class": "col-xl-4 pb-2",
          page: _vm.headers.page,
          "right-side-class":
            "col-xl-8 align-items-end d-flex pb-4 justify-content-end"
        }
      }),
      _vm.isReturned
        ? _c(
            "div",
            {
              staticClass: "p-3 returned-box",
              style: { borderLeftColor: _vm.model.status?.color }
            },
            [
              _c("icon-view", {
                style: { "--icon-color": _vm.model.status?.color },
                attrs: {
                  icon: "fas fa-undo mb-1",
                  "icon-size": "16px",
                  title: "Devuelto"
                }
              }),
              _c("div", { staticClass: "m-2" }, [
                _c("div", { staticClass: "font-16 color-black" }, [
                  _vm._v(" Razón de devolución: ")
                ]),
                _c("div", { staticClass: "font-14 color-gray-6" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("empty")(
                          _vm._f("first")(_vm.model.logs, _vm.model.status?.id)
                        )
                      ) +
                      " "
                  )
                ])
              ])
            ],
            1
          )
        : _vm._e(),
      _c("board", {
        staticClass: "my-3",
        attrs: { details: _vm.board },
        scopedSlots: _vm._u([
          {
            key: "data-item",
            fn: function({ item }) {
              return [
                item.status
                  ? _c(
                      "div",
                      [
                        _c("custom-balloon", {
                          attrs: {
                            "background-color": item.status.color,
                            dot: "",
                            text: item.status.name
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            }
          }
        ])
      }),
      _c(
        "validation-observer",
        { ref: "formValidator" },
        [
          _c(
            "b-tabs",
            {
              class: { "three-tabs": _vm.isSubmitted },
              attrs: {
                "content-class": "my-3",
                "nav-class": "custom-nav-container",
                "no-nav-style": ""
              },
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            [
              _c(
                "b-tab",
                {
                  staticClass: "purchase-service-tabs",
                  attrs: {
                    id: "request",
                    lazy: false,
                    title: "Solicitud Contratación de Servicios"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function() {
                        return [
                          _c(
                            "span",
                            {
                              class: {
                                "tab-title-error": _vm.tabErrorKey === "request"
                              }
                            },
                            [
                              _vm._v(" Solicitud Contratación de Servicios "),
                              _vm.tabErrorKey === "request"
                                ? _c("i", {
                                    staticClass:
                                      "fas fa-exclamation-triangle text-danger ml-1"
                                  })
                                : _vm._e()
                            ]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _c(
                    "div",
                    { staticClass: "my-3" },
                    [
                      _c("div", { staticClass: "row my-2" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col-12 d-flex justify-content-lg-end"
                          },
                          [
                            _c("action-button", {
                              staticClass: "outline-dark-gray",
                              attrs: {
                                i: _vm.anyCollapseOpen
                                  ? "fal fa-compress-alt"
                                  : "fal fa-expand-alt",
                                text: _vm.anyCollapseOpen
                                  ? "Colapsar Todo"
                                  : "Expandir Todo"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.expandAll(!_vm.anyCollapseOpen)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _c("request-information", {
                        attrs: {
                          id: _vm.id,
                          "government-levels": _vm.catalogs.governmentLevels,
                          "is-amendment-renewal": _vm.isAmendmentRenewal,
                          "is-read-only": _vm.isSubmitted,
                          programs: _vm.catalogs.programs
                        },
                        on: {
                          contractors: _vm.onCompetitionProcessContractsChange,
                          "reset-contractors": _vm.resetContracts,
                          search: _vm.onSearchPrevious
                        },
                        model: {
                          value: _vm.model,
                          callback: function($$v) {
                            _vm.model = $$v
                          },
                          expression: "model"
                        }
                      }),
                      _c("contact-info", {
                        attrs: {
                          "is-read-only": _vm.isSubmitted,
                          offices: _vm.catalogs.contactOffices,
                          "show-slot": !_vm.isAmendmentRenewal
                        },
                        model: {
                          value: _vm.model.detail,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "detail", $$v)
                          },
                          expression: "model.detail"
                        }
                      }),
                      _vm.canView(_vm.sections.ContractorContactInformation)
                        ? _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ validated }) {
                                    return [
                                      _c("contractor-info", {
                                        ref: "contractorInfo",
                                        attrs: {
                                          contractors: _vm.contractors,
                                          "is-competition-process-from-mipe":
                                            _vm.model.detail
                                              ?.isCompetitionProcessFromMipe,
                                          "is-read-only": _vm.isSubmitted
                                        },
                                        on: {
                                          "load-contractors":
                                            _vm.onLoadContractors
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "contractor-error",
                                              fn: function() {
                                                return [
                                                  validated &&
                                                  !_vm.model.detail.contractors
                                                    ?.length
                                                    ? _c("error", {
                                                        attrs: {
                                                          message:
                                                            "Debe haber al menos 1 contratista agregado.",
                                                          variant: "no-border"
                                                        }
                                                      })
                                                    : _vm._e()
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: _vm.model.detail.contractors,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.model.detail,
                                              "contractors",
                                              $$v
                                            )
                                          },
                                          expression: "model.detail.contractors"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2580178099
                            )
                          })
                        : _vm._e(),
                      _vm.canView(_vm.sections.ContractJustification)
                        ? _c("contract-justification", {
                            attrs: { "is-read-only": _vm.isSubmitted },
                            model: {
                              value: _vm.model.detail.contractJustification,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model.detail,
                                  "contractJustification",
                                  $$v
                                )
                              },
                              expression: "model.detail.contractJustification"
                            }
                          })
                        : _vm._e(),
                      _vm.canView(_vm.sections.PublicFundsServicesSection)
                        ? _c("public-funds-services", {
                            attrs: { "is-read-only": _vm.isSubmitted },
                            model: {
                              value:
                                _vm.model.detail.serviceRelationshipPublicFunds,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model.detail,
                                  "serviceRelationshipPublicFunds",
                                  $$v
                                )
                              },
                              expression:
                                "model.detail.serviceRelationshipPublicFunds"
                            }
                          })
                        : _vm._e(),
                      _vm.canView(_vm.sections.ExplanatoryFields)
                        ? _c("explanatory-fields", {
                            attrs: {
                              "government-levels":
                                _vm.catalogs.governmentLevels,
                              "is-read-only": _vm.isSubmitted
                            },
                            model: {
                              value: _vm.model.detail,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "detail", $$v)
                              },
                              expression: "model.detail"
                            }
                          })
                        : _vm._e(),
                      _vm.canView(_vm.sections.BudgetSourceFunds)
                        ? _c(
                            "collapse",
                            {
                              attrs: {
                                title:
                                  "Partida presupuestaria y/o procedencia de los fondos"
                              }
                            },
                            [
                              _c("budget-source-funds", {
                                attrs: {
                                  "is-read-only": _vm.isSubmitted,
                                  model: _vm.model.detail,
                                  "program-types": _vm.catalogs.governmentLevels
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.canView(_vm.sections.ServicesRequested)
                        ? _c("services-requested", {
                            attrs: {
                              "is-read-only": _vm.isSubmitted,
                              model: _vm.model.detail
                            }
                          })
                        : _vm._e(),
                      _vm.canView(_vm.sections.ContractInformation)
                        ? _c("contract-information", {
                            ref: "contractInformation",
                            attrs: {
                              contractors: _vm.model.detail.contractors,
                              contracts: _vm.contracts,
                              "determination-categories":
                                _vm.catalogs.determinationCategories,
                              "determination-category":
                                _vm.previousRequest?.determinationCategoryId,
                              "is-read-only": _vm.isSubmitted,
                              "program-types": _vm.catalogs.governmentLevels,
                              type: _vm.model.contractType?.id
                            },
                            on: { "load-contracts": _vm.onLoadContracts },
                            model: {
                              value: _vm.model.detail,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "detail", $$v)
                              },
                              expression: "model.detail"
                            }
                          })
                        : _vm._e(),
                      _vm.canView(_vm.sections.PaymentAmount)
                        ? _c("payment-amount", {
                            attrs: {
                              "is-amount-required": _vm.hasBudgetSourceFunds,
                              "is-read-only": _vm.isSubmitted
                            },
                            model: {
                              value:
                                _vm.model.detail.competitionProcessContracts,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model.detail,
                                  "competitionProcessContracts",
                                  $$v
                                )
                              },
                              expression:
                                "model.detail.competitionProcessContracts"
                            }
                          })
                        : _vm._e(),
                      _vm.canView(_vm.sections.CostAnalysis)
                        ? _c("cost-analysis", {
                            attrs: { "is-read-only": _vm.isSubmitted },
                            model: {
                              value: _vm.model.detail,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "detail", $$v)
                              },
                              expression: "model.detail"
                            }
                          })
                        : _vm._e(),
                      _vm.canView(_vm.sections.ContractRenewal)
                        ? _c("contract-renewal", {
                            attrs: {
                              "is-read-only": _vm.isSubmitted,
                              model: _vm.model.detail
                            }
                          })
                        : _vm._e(),
                      _vm.canView(_vm.sections.FullDescription)
                        ? _c("full-description", {
                            ref: "fullDescriptionFields",
                            attrs: { "is-read-only": _vm.isSubmitted },
                            model: {
                              value: _vm.model.detail,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "detail", $$v)
                              },
                              expression: "model.detail"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _c(
                "b-tab",
                {
                  staticClass: "purchase-service-tabs",
                  attrs: { id: "documents", lazy: false },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function() {
                        return [
                          _c(
                            "span",
                            {
                              class: {
                                "tab-title-error":
                                  _vm.tabErrorKey === "documents"
                              }
                            },
                            [
                              _vm._v(" Documentos de Respaldo "),
                              _vm.tabErrorKey === "documents"
                                ? _c("i", {
                                    staticClass:
                                      "fas fa-exclamation-triangle text-danger ml-1"
                                  })
                                : _vm._e()
                            ]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _c("supporting-documents", {
                    ref: "supportingDocuments",
                    attrs: {
                      "document-types": _vm.catalogs.supportingDocumentTypes,
                      "is-read-only": _vm.isSubmitted
                    },
                    model: {
                      value: _vm.model.supportingDocuments,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "supportingDocuments", $$v)
                      },
                      expression: "model.supportingDocuments"
                    }
                  })
                ],
                1
              ),
              _vm.canViewSignedTab
                ? _c(
                    "b-tab",
                    {
                      staticClass: "purchase-service-tabs",
                      attrs: { id: "signature", lazy: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "tab-title-error":
                                        _vm.tabErrorKey === "signature"
                                    }
                                  },
                                  [
                                    _vm._v(" Firma "),
                                    _vm.tabErrorKey === "signature"
                                      ? _c("i", {
                                          staticClass:
                                            "fas fa-exclamation-triangle text-danger ml-1"
                                        })
                                      : _vm._e()
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        1507720659
                      )
                    },
                    [
                      _vm.loadingSignature
                        ? _c(
                            "div",
                            { staticClass: "mt-3" },
                            [
                              _c(
                                "b-card",
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c("b-skeleton", {
                                            attrs: { width: "85%" }
                                          }),
                                          _c("b-skeleton", {
                                            attrs: { width: "55%" }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        [
                                          _c("b-skeleton", {
                                            attrs: { width: "70%" }
                                          }),
                                          _c("b-skeleton", {
                                            attrs: { width: "55%" }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        [
                                          _c("b-skeleton", {
                                            attrs: { width: "85%" }
                                          }),
                                          _c("b-skeleton", {
                                            attrs: { width: "55%" }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        [
                                          _c("b-skeleton", {
                                            attrs: { width: "70%" }
                                          }),
                                          _c("b-skeleton", {
                                            attrs: { width: "55%" }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        [
                                          _c("b-skeleton", {
                                            attrs: {
                                              type: "button",
                                              width: "100%"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.loadingSignature
                        ? [
                            _c("sign-plan", {
                              ref: "signPlanRef",
                              staticClass: "my-4",
                              attrs: {
                                disabled: _vm.isElectronicDisabled,
                                "is-electronic-signature":
                                  _vm.model.isElectronicSignature,
                                "question-label":
                                  "¿Cuál será el mecanismo que se estará utilizando para firmar la Solicitud Contratación de Servicios?"
                              },
                              on: {
                                "update:isElectronicSignature": function(
                                  $event
                                ) {
                                  return _vm.$set(
                                    _vm.model,
                                    "isElectronicSignature",
                                    $event
                                  )
                                },
                                "update:is-electronic-signature": function(
                                  $event
                                ) {
                                  return _vm.$set(
                                    _vm.model,
                                    "isElectronicSignature",
                                    $event
                                  )
                                }
                              }
                            }),
                            _c(
                              "div",
                              { staticClass: "mt-4" },
                              [
                                _vm.hasSelectMechanisManuscript
                                  ? _c(
                                      "div",
                                      [
                                        _c("section-title", {
                                          attrs: {
                                            "has-line": "",
                                            title: "Documento"
                                          }
                                        }),
                                        _vm.document
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row bg-secondary-3 rounded p-3 mb-3 ml-1 mr-0"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "col-md-6" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "color-gray-6 font-14 font-weight-normal"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Tipo de Documento: "
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "color-black font-16 font-weight-normal"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.document
                                                                .documentTypeName
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-md-6 d-flex justify-content-center"
                                                  },
                                                  [
                                                    _vm.hasManuscriptDocUploaded &&
                                                    !_vm.editingDocument
                                                      ? _c(
                                                          "div",
                                                          [
                                                            _vm.canChangeSignedDocument
                                                              ? _c(
                                                                  "action-button",
                                                                  {
                                                                    staticClass:
                                                                      "mr-2 mt-1 outline-success",
                                                                    attrs: {
                                                                      i:
                                                                        "fas fa-undo mr-n1 pr-1",
                                                                      variant:
                                                                        "success"
                                                                    },
                                                                    on: {
                                                                      click: () =>
                                                                        (_vm.editingDocument = true)
                                                                    }
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "action-button",
                                                              {
                                                                staticClass:
                                                                  "mt-1",
                                                                attrs: {
                                                                  i:
                                                                    "fas fa-file-download text-white mr-n1 pr-1",
                                                                  variant:
                                                                    "success"
                                                                },
                                                                on: {
                                                                  click:
                                                                    _vm.downloadDocument
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm.hasDownloadedTemplate ||
                                                        _vm.editingDocument
                                                      ? _c(
                                                          "div",
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "color-gray-6 font-14 font-weight-normal mr-3 mt-2"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Documento: "
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "validation-provider",
                                                              {
                                                                attrs: {
                                                                  rules: {
                                                                    required: true
                                                                  }
                                                                },
                                                                scopedSlots: _vm._u(
                                                                  [
                                                                    {
                                                                      key:
                                                                        "default",
                                                                      fn: function({
                                                                        errors
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "custom-file-input",
                                                                            {
                                                                              ref:
                                                                                "documentInform",
                                                                              attrs: {
                                                                                accept:
                                                                                  ".pdf",
                                                                                "attachment-id":
                                                                                  _vm
                                                                                    .document
                                                                                    .documentId,
                                                                                "custom-error-msg":
                                                                                  "Favor de anejar un documento.",
                                                                                "display-style":
                                                                                  "normal",
                                                                                error:
                                                                                  errors[0],
                                                                                "label-position":
                                                                                  "left",
                                                                                required:
                                                                                  ""
                                                                              },
                                                                              on: {
                                                                                input: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.saveSignedDocument(
                                                                                    $event
                                                                                  )
                                                                                }
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  _vm
                                                                                    .document
                                                                                    .selectedDocument,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.document,
                                                                                    "selectedDocument",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                                expression:
                                                                                  "document.selectedDocument"
                                                                              }
                                                                            }
                                                                          )
                                                                        ]
                                                                      }
                                                                    }
                                                                  ],
                                                                  null,
                                                                  false,
                                                                  2159158541
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _c("action-button", {
                                                          staticClass: "mt-1",
                                                          attrs: {
                                                            i:
                                                              "fas fa-file-download text-white mr-n1 pr-1",
                                                            variant: "success"
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.downloadTemplate
                                                          }
                                                        })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm.hasSelectMechanismElectronic
                                  ? _c("signature-hub-info", {
                                      attrs: {
                                        "signature-info": _vm.signatureHubInfo
                                      },
                                      on: {
                                        "configure-sign":
                                          _vm.handleConfigureSignatures
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }